module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/170.be562277.png";